import React from "react";

interface PayoutStatProps {
	label: string;
	value: React.ReactNode;
	/** The figure the admin is about to act on — drawn in the brand colour. */
	highlight?: boolean;
}

const PayoutStat = ({ label, value, highlight = false }: PayoutStatProps) => (
	<div
		className={`rounded-lg border px-4 py-3 ${
			highlight ? "border-[#4F16C2] bg-[#4F16C2]/5" : "border-gray-200"
		}`}
	>
		<div className="text-sm text-gray-500">{label}</div>
		<div
			className={`text-xl font-semibold ${
				highlight ? "text-[#4F16C2]" : "text-gray-900"
			}`}
		>
			{value}
		</div>
	</div>
);

export default PayoutStat;
